import React from 'react';
import { Box } from '@mui/material';
import LandingHeader from './sections/LandingHeader';
import LandingHero from './sections/LandingHero';
import LandingFeatures from './sections/LandingFeatures';
import LandingAbout from './sections/LandingAbout';
import LandingStats from './sections/LandingStats';
import LandingFooter from './sections/LandingFooter';

const LandingPage = () => (
  <Box sx={{ bgcolor: '#F9FAFB', minHeight: '100vh' }}>
    <LandingHeader />
    <LandingHero />
    <LandingFeatures />
    <LandingAbout />
    <LandingStats />
    <LandingFooter />
  </Box>
);

export default LandingPage;
